import {otsBaseApi} from "../../ots-api";
import {ContainerAlert} from "../../../model/container-alert";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["ContainerAlerts"]});

const containerAlertApi = taggedBaseApi.injectEndpoints({
    endpoints: (builder) => ({
        getContainerAlert: builder.query<ContainerAlert, string>({
            query: (id) => ({
                url: `/container-alerts/${id}`,
                method: "GET",
            }),
            providesTags: (result, error, id) => [{type: "ContainerAlerts", id}]
        })
    })
});

export const {
    useGetContainerAlertQuery
} = containerAlertApi;
